
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortLink]",
      function () {
        return require("private-next-pages/[shortLink].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortLink]"])
      });
    }
  